import React, { useState } from 'react'

const AvatarWithInfoBox = ({ data, isRight }) => {
    const [showInfo, setShowInfo] = useState(true);
    let user, userBusiness = [];

    try {
        user = JSON.parse(data?.Dados_Usuario)[0]
        userBusiness = JSON.parse(user?.Coluna_Empresas_Usuario)
    } catch (error) {
        console.log("usuario nao encontrado: ", error)
    }
    
    return (
        <div className='container-avatar-with-box-info'>
            <div className='avatar-with-box-info'>
                <div className="d-flex gap-2">
                    {data?.Foto_Usuario ? (
                        <div className='container-avatar'>
                            <div className="photo-user" onMouseEnter={() => { if (!showInfo) setShowInfo(true) }} onMouseLeave={() => setShowInfo(false)}> <img src={data?.Foto_Usuario} /> </div>
                            <div className={`modal-info ${isRight ? 'right-box' : 'left-box'}`}>
                                <div className='row'>
                                    <div className='col-auto'>
                                        {data?.Foto_Usuario ? <div className="photo-user"> <img style={{ width: 120, height: 120 }} src={data?.Foto_Usuario} /> </div>
                                            : <i
                                                className="far fa-user-circle user-photo-label "
                                                style={{ fontSize: 32 }}
                                                aria-hidden="true"
                                            />
                                        }
                                    </div>
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col-12 pb-1'>
                                                <p className='font-size-20 text-color-azul1 font-w-600'>{user?.Nome_Completo} ({user?.Apelido})</p>
                                            </div>
                                            <div className='col-12 pb-3'>
                                                <p className='font-size-14 text-color-cinza4 font-w-400'>{user?.Departamento}</p>
                                            </div>
                                            <div className='col-12'>
                                                <div className='d-flex align-items-center flex-wrap gap-2'>
                                                    {userBusiness?.map((item, index) => (
                                                        <img src={item?.valor} style={{ width: 32 }} className='rounded-circle photo-user' />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div className='col-12 d-flex align-items-center gap-2 pt-3'>
                                        <i class="fa-regular fa-envelope text-color-azul2 font-size-20"></i>
                                        <span className='font-size-14 text-color-cinza4 font-w-400'>{user?.Email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                        : <i
                            className="far fa-user-circle user-photo-label "
                            style={{ fontSize: 32 }}
                            aria-hidden="true"
                        />
                    }
                    <div className="d-flex align-items-center">
                        <span className="font-size-16 text-color-azul1 font-w-600">
                            {data?.Nome_Completo}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AvatarWithInfoBox